import React, { useEffect, useState } from "react";
import "./pages.css";

import Table from "react-bootstrap/Table";
import { firebase } from "../firebase";
import { Button } from "react-bootstrap";

const PriceSensitiveInformation = () => {
  useEffect(() => {
    document.title = " Price Sensitive information | Star Adhesives";
  }, []);
  const [tableData, setTableData] = useState({});
  useEffect(() => {
    firebase
      .database()
      .ref("StarAdhesive")
      .child("UploadFiles")
      .child("PriceSensitiveInformation")
      .on("value", (snapshot) => {
        if (snapshot.val() != null) {
          setTableData({ ...snapshot.val() });
        }
      });
  }, []);
  console.log(tableData);

  return (
    <>
      <div className="aboutUs">
        <div class="bod ">
          <img src="assets/images/BOD.jpg" />
          <div className="titleText">
            <h2> Price Sensitive information</h2>
          </div>
        </div>
      </div>

      <div className="bodsec2">
        <div className="container fluid">
          <div className="row">
            <h2>Price Sensitive Information</h2>
            <hr />
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Sl.</th>
                  <th>File Name</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(tableData).map((id, index) => {
                  return (
                    <tr key={id}>
                      <td>{index + 1}</td>
                      <td>{tableData[id].FileName}</td>
                      <td>
                        <Button
                          href={tableData[id].DownloadUrl}
                          variant="primary"
                          size="md"
                          target="_blank"
                        >
                          Download
                        </Button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </>
  );
};

export default PriceSensitiveInformation;
